module.exports = __webpack_public_path__ + "img/bs-short-logo.0c220729.svg";